// web-vitals s'ha desactivat: la llibreria (v3+) llança
// "Cannot read properties of undefined (reading 'startTime')" dins de
// reportAllChanges en dev, i no s'estava fent servir cap handler.
// Es deixa un no-op per no trencar la crida des de index.tsx.
const reportWebVitals = (_onPerfEntry?: unknown) => {
    // Intencionadament buit: no carreguem 'web-vitals'.
};

export default reportWebVitals;
